import React from "react";

export default function Mentions() {
  return (
    <div className="text-white/50 container p-5">
      <div className="text-center my-20">
        <h1 className="text-3xl text-white  overflow-hidden">Mentions légales</h1>
        <p>En vigueur au 26/09/2022</p>
      </div>
      <div className=" p-5">
      Conformément aux dispositions des Articles 6-III et 19 de la Loi
      n°2004-575 du 21 juin 2004 pour la Confiance dans l’économie numérique,
      dite L.C.E.N., il est porté à la connaissance des utilisateurs et
      visiteurs, ci-après l""Utilisateur", du site
      https://frontcodelover.vercel.app/ , ci-après le "Site", les présentes
      mentions légales. La connexion et la navigation sur le Site par
      l’Utilisateur implique acceptation intégrale et sans réserve des présentes
      mentions légales. Ces dernières sont accessibles sur le Site à la rubrique
      « Mentions légales ». 
      <h2 className="text-white text-2xl my-9">ARTICLE 1 - L'EDITEUR</h2> 
      
      L’édition et la direction de
      la publication du Site est assurée par Nicolas DE RAEMY, domiciliée 2 Imp.
      des Changes Chartres, dont l'adresse e-mail job@nicolasderaemy.fr.
      ci-après l'"Editeur". 
      
      <h2 className="text-white text-2xl my-9">ARTICLE 2 - L'HEBERGEUR</h2>
      
       L'hébergeur du Site est la
      société Vercel Inc., dont le siège social est situé au 340 S Lemon Ave
      #4133 Walnut, CA 91789. 
      
      <h2 className="text-white text-2xl my-9">ARTICLE 3 - ACCES AU SITE</h2>
      
       Le Site est accessible
      en tout endroit, 7j/7, 24h/24 sauf cas de force majeure, interruption
      programmée ou non et pouvant découlant d’une nécessité de maintenance. En
      cas de modification, interruption ou suspension du Site, l'Editeur ne
      saurait être tenu responsable. 
      
      <h2 className="text-white text-2xl my-9">ARTICLE 4 - COLLECTE DES DONNEES</h2>
      
       Le Site
      assure à l'Utilisateur une collecte et un traitement d'informations
      personnelles dans le respect de la vie privée conformément à la loi
      n°78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et aux
      libertés. En vertu de la loi Informatique et Libertés, en date du 6
      janvier 1978, l'Utilisateur dispose d'un droit d'accès, de rectification,
      de suppression et d'opposition de ses données personnelles. <p className="my-4">L'Utilisateur
      exerce ce droit : · par mail à l'adresse email job@nicolasderaemy.fr</p> Toute
      utilisation, reproduction, diffusion, commercialisation, modification de
      toute ou partie du Site, sans autorisation de l’Editeur est prohibée et
      pourra entraînée des actions et poursuites judiciaires telles que
      notamment prévues par le Code de la propriété intellectuelle et le Code
      civil.
      </div>
    </div>
  );
}
